import React, { useState, useEffect } from "react";
import { useOutletContext } from "react-router-dom";
import { Star, ChevronLeft, ChevronRight } from "lucide-react";

const testimonials = [
  {
    quote: "The Hive feels like the right mix of professionalism and community and the team is always supportive",
    name: "Bhavya",
    role: "Innoviz",
  },
  {
    quote: "We’re really happy with the positive work environment and the quick support from the Hive team",
    name: "Aastha",
    role: "Cognida",
    image: "/testimonials/cognida.png"
  },

  {
    quote: "Well-maintained space with good amenities and a responsive team",
    name: "Moyer",
    role: "Moschip",
    image: "/testimonials/moschip.jpeg"
  },


  {
    quote: "The floor is well managed with accessible lifts and consistently maintained amenities",
    name: "Nachiket",
    role: "Quantzig",
    image: "/testimonials/quantzig.jpeg"
  },
  {
    quote: "Great ambience, smooth facilities and a team that’s always responsive",
    name: "Bikash",
    role: "Infiniti",
    image: "/testimonials/infiniti.jpeg"
  },
  {
    quote: "Great ambience, clean facilities and a supportive operations team",
    name: "Preeti",
    role: "Moschip",
    image: "/testimonials/moschip.jpeg"
  },
  {
    quote: "Games and vending facilities add to a comfortable work setup",
    name: "Sachin",
    role: "Infiniti",
    image: "/testimonials/infiniti.jpeg"
  },
  {
    quote: "I’d happily rate The Hive 4.5/5 for its space, facilities and prompt team support",
    name: "Vijay Laxmi",
    role: "Quantzig",
    image: "/testimonials/quantzig.jpeg"
  },
  {
    quote: "Calm, spacious workspace with clean facilities and reliable team support",
    name: "Kavya",
    role: "OLR",
    image: "/testimonials/olr.png"
  },
  {
    quote: "The ambience, games and overall setup make it a comfortable and enjoyable place to work",
    name: "Neeshu",
    role: "Quantzig",
    image: "/testimonials/quantzig.jpeg"
  },
  {
    quote: "Games and vending amenities make the workspace more enjoyable",
    name: "Babasai",
    role: "OLR",
    image: "/testimonials/olr.png"
  }
];

export default function Testimonials() {
  const { theme } = useOutletContext();
  const [currentIndex, setCurrentIndex] = useState(0);

  const handlePrev = () => {
    setCurrentIndex((prevIndex) => (prevIndex - 1 + testimonials.length) % testimonials.length);
  };

  const handleNext = () => {
    setCurrentIndex((prevIndex) => (prevIndex + 1) % testimonials.length);
  };

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prevIndex) => (prevIndex + 1) % testimonials.length);
    }, 5000); // Auto-slide every 5 seconds

    return () => clearInterval(interval);
  }, []);

  return (
    <div className={`w-full ${theme === "dark" ? "bg-black" : "bg-white"}`}>
      <section className={`max-w-[90%] mx-auto px-4 py-4 relative overflow-hidden ${theme === "dark" ? "text-white bg-black" : "text-black bg-white"}`}>
        <div className="mx-auto">
          {/* Heading */}
          <div className="flex flex-col lg:flex-row justify-center items-start lg:items-center  relative z-10">
            <div>
              {/* <p className={`${theme === "dark" ? "text-gray-400" : "text-gray-500"} text-sm mb-2 `}>/ Testimonials /</p> */}
              <h2 className={`text-4xl leading-snug mb-4 liber ${theme === "dark" ? "text-white" : "text-black"}`}>
                Voices of Our Community
              </h2>
            </div>

          </div>

          {/* Testimonials Slider */}
          <div
            className="relative rounded-xl overflow-hidden"
            id="testimonials"
            style={{
              minHeight: '250px',
              position: 'relative'
            }}
          >
            {/* Slider Container */}
            <div className={`relative overflow-hidden rounded-xl `} >
              <div
                className="flex transition-transform duration-700 ease-in-out"
                style={{
                  transform: `translateX(-${currentIndex * 100}%)`,
                }}
              >
                {testimonials.map((t, index) => (
                  <div
                    key={index}
                    className="w-full flex-shrink-0 px-8 md:px-16 lg:px-12 py-3 flex items-center justify-center "
                    id={`testimonial-${index}`}
                  >
                    <div
                      className={`relative z-10 rounded-xl p-6 md:p-8 max-w-6xl w-full flex flex-col justify-center backdrop-blur-md border shadow-lg ${theme === "dark"
                        ? "bg-white/90 border-white/20"
                        : "bg-black/90 border-black/20"
                        }`}
                      style={{
                        backdropFilter: 'blur(12px) saturate(180%)',
                        WebkitBackdropFilter: 'blur(12px) saturate(180%)',
                      }}
                    >
                      <p className={`mb-4 leading-relaxed text-lg md:text-xl text-center ${theme === "dark" ? "text-gray-900" : "text-gray-100"
                        }`}>
                        "{t.quote}"
                      </p>

                      <div className="flex flex-col items-center justify-center gap-4 mt-6">

                        {/* {t.image && (
                          <div className="bg-white p-2 rounded-lg shadow-sm flex items-center justify-center border border-black/5">
                            <img
                              src={t.image}
                              alt={t.role}
                              className="h-8 w-auto object-contain"
                            />
                          </div>
                        )} */}
                        <div>
                          <p className={`font-semibold text-center uppercase text-lg ${theme === "dark" ? "text-black" : "text-white"
                            }`}>
                            {t.role}
                          </p>
                          {/* <p className={`text-center text-sm mt-1 ${theme === "dark" ? "text-gray-600" : "text-white/70"
                            }`}>
                            {t.name}
                          </p> */}
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>

            {/* Navigation Buttons */}
            <div className="absolute top-[97px] left-4 transform -translate-y-1/2 z-10">
              <button
                onClick={handlePrev}
                className={`p-3 rounded-full shadow-lg transition-all duration-300 ${theme === "dark" ? 'bg-white/90 text-black hover:bg-white' : 'bg-black/90 text-white hover:bg-black'}`}
                aria-label="Previous testimonial"
              >
                <ChevronLeft size={24} />
              </button>
            </div>
            <div className="absolute top-[97px] right-4 transform -translate-y-1/2 z-10">
              <button
                onClick={handleNext}
                className={`p-3 rounded-full shadow-lg transition-all duration-300 ${theme === "dark" ? 'bg-white/90 text-black hover:bg-white' : 'bg-black/90 text-white hover:bg-black'}`}
                aria-label="Next testimonial"
              >
                <ChevronRight size={24} />
              </button>
            </div>

            {/* Dots Indicator */}
            <div className="flex justify-center gap-2 mt-8">
              {testimonials.map((_, index) => (
                <button
                  key={index}
                  onClick={() => setCurrentIndex(index)}
                  className={`w-2 h-2 rounded-full transition-all duration-300 ${index === currentIndex
                    ? (theme === "dark" ? 'bg-white w-8' : 'bg-black w-8')
                    : (theme === "dark" ? 'bg-white/30 hover:bg-white/50' : 'bg-black/20 hover:bg-black/40')
                    }`}
                  aria-label={`Go to testimonial ${index + 1}`}
                />
              ))}
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
